'use strict';

import angular from 'angular';
import EditController from './edit.controller';

export default angular.module('updateServerApp.appstore.edit', [])
  .controller('AppStoreEditController', EditController)
  .name;



// WEBPACK FOOTER //
// ./client/app/appstore/edit/index.js